export var context = {
  zIndex: 2000,
  lockCount: 0,
  stack: [],

  get top() {
    return this.stack[this.stack.length - 1];
  }

};


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vant@1.6.17@vant/es/mixins/popup/context.js
// module id = null
// module chunks = 